module.exports = __webpack_public_path__ + "img/stolen-vehicle-recovery-process.ec45c029.svg";